import React, { createContext, useState } from "react";

export const IsHomePageContext = createContext();

const IsHomePage = ({ children }) => {
  const [isHomePage, setIsHomePage] = useState(true);

  const setHomePage = (value) => {
    setIsHomePage(value);
  };

  return (
    <IsHomePageContext.Provider value={{ isHomePage, setHomePage }}>
      {children}
    </IsHomePageContext.Provider>
  );
};

export default IsHomePage;
